import React from "react";
import PlaceOrder from "./pages/place-order";

const AboutUs = React.lazy(() => import("./pages/About"));;
const Compare = React.lazy(() => import("./pages/Compare"));;
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));;
const TermsConditions = React.lazy(() => import("./pages/TermsConditions"));;
const ContactUs = React.lazy(() => import("./pages/Contact-us"));;
const Error404 = React.lazy(() => import("./pages/Error404"));;
const Home = React.lazy(() => import("./pages/Home"));;
const Inquiry = React.lazy(() => import("./pages/Inquiry"));;
const Products = React.lazy(() => import("./pages/products"));;

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        exact: true,
        isActive: true,
        seo: {
            title: "N S Solution | HVAC, Plumbing & Firefighting Distributor in Surat",
            description:
                "Authorized distributor, dealer, stockist and importer of leading HVAC, plumbing and firefighting brands. Quality products and timely delivery from Surat, India.",
        },
    },
    {
        path: "/contact-us",
        name: "Contact Us",
        component: ContactUs,
        exact: true,
        isActive: true,
        seo: {
            title: "Contact Us",
            description:
                "Get in touch with N S Solution in Surat for HVAC, plumbing and firefighting products. Call +91 9377075095 or email sales@nidhicorp.com.",
        },
    },
    {
        path: "/about-us",
        name: "About Us",
        component: AboutUs,
        exact: true,
        isActive: true,
        seo: {
            title: "About Us",
            description:
                "Learn about N S Solution — a leading distributor and importer of HVAC, plumbing and firefighting brands committed to quality and timely delivery.",
        },
    },
    {
        path: "/inquiry",
        name: "Inquiry",
        component: Inquiry,
        exact: true,
        isActive: true,
        seo: {
            title: "Product Inquiry",
            description:
                "Send a product inquiry to N S Solution for HVAC, plumbing and firefighting supplies and get a prompt response from our team.",
        },
    },
    {
        path: "/place-order",
        name: "Place Order",
        component: PlaceOrder,
        exact: true,
        isActive: true,
        seo: {
            title: "Place an Order",
            description:
                "Place an order with N S Solution for HVAC, plumbing and firefighting products with reliable and timely delivery.",
            noindex: true,
        },
    },
    {
        path: "/products/:brand?",
        name: "Products",
        component: Products,
        exact: true,
        isActive: true,
        seo: {
            title: "Products",
            description:
                "Browse N S Solution's range of HVAC, plumbing and firefighting products from trusted national and international brands.",
        },
    },
    {
        path: "/products",
        name: "Products",
        component: Products,
        exact: true,
        isActive: true,
        seo: {
            title: "Products",
            description:
                "Browse N S Solution's range of HVAC, plumbing and firefighting products from trusted national and international brands.",
        },
    },
    {
        path: "/compare",
        name: "Compare",
        component: Compare,
        exact: true,
        isActive: true,
        seo: {
            title: "Compare Products",
            description:
                "Compare HVAC, plumbing and firefighting products side by side to find the right fit for your requirements with N S Solution.",
            noindex: true,
        },
    },
    {
        path: "/privacy-policy",
        name: "Privacy Policy",
        component: PrivacyPolicy,
        exact: true,
        isActive: true,
        seo: {
            title: "Privacy Policy",
            description:
                "Read the Privacy Policy of N S Solution to understand how we collect, use, and protect your personal information.",
        },
    },
    {
        path: "/terms-and-conditions",
        name: "Terms & Conditions",
        component: TermsConditions,
        exact: true,
        isActive: true,
        seo: {
            title: "Terms & Conditions",
            description:
                "Review the Terms & Conditions of N S Solution for using our website, products, and services.",
        },
    },
    {
        path: "/404",
        name: "404",
        component: Error404,
        exact: true,
        isActive: true,
        seo: {
            title: "Page Not Found",
            description: "The page you are looking for could not be found.",
            noindex: true,
        },
    },
];

export default routes;